import { useContext } from "react";

import FnrTypography from "FnrTypography";

import { formatCurrencyWithCommas } from "Utilities/Number";

import { EditorContext } from "./Editor";

const Amount = () => {
  const { amount } = useContext(EditorContext);

  return (
    <FnrTypography fontSize="lg" bold>
      ${formatCurrencyWithCommas(amount)}
    </FnrTypography>
  );
};

export default Amount;
